export default __webpack_public_path__ + "static/media/133631843_1307631789615026_939976124895431361_o (1).2f97933e.jpg";